import { render } from "./Epley_warnings.vue?vue&type=template&id=a1268552"
import script from "./Epley_warnings.vue?vue&type=script&lang=js"
export * from "./Epley_warnings.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__